import { withInstall } from '../../../utils/with-install'
import PolygonLayer from './PolygonLayer.vue'

export const ElAmapLocaPolygon = withInstall(PolygonLayer)
export default ElAmapLocaPolygon
